export default __webpack_public_path__ + "static/media/white-polygon-measure-icon.514b4adc.svg";